import { createSlice } from "@reduxjs/toolkit";

// The signed-in shopper's own orders, newest first, loaded a page at a time
const initialState = {
    orders: [],
    page: 0,
    pages: 0,
    total: 0,
    loading: false,
    error: null,
};

const orderSlice = createSlice({
    name: "order",
    initialState,
    reducers: {
        setLoading: (state) => {
            state.loading = true;
            state.error = null;
        },
        // payload: { orders, page, pages, total }. Page 1 replaces the list, later pages are added to it.
        setOrders: (state, action) => {
            const { orders, page, pages, total } = action.payload;
            state.orders = page > 1 ? [...state.orders, ...orders] : orders;
            state.page = page;
            state.pages = pages;
            state.total = total;
            state.loading = false;
        },
        addOrder: (state, action) => {
            state.orders = [action.payload, ...state.orders];
            state.total += 1;
        },
        // payload: an order as returned by the server, replacing the one with the same id
        updateOrder: (state, action) => {
            state.orders = state.orders.map((order) => (order.id === action.payload.id ? action.payload : order));
        },
        setError: (state, action) => {
            state.error = action.payload;
            state.loading = false;
        },
        clearOrders: () => initialState,
    },
});

export const { setLoading, setOrders, addOrder, updateOrder, setError, clearOrders } = orderSlice.actions;
export const selectOrders = (state) => state.order;

export default orderSlice.reducer;
